import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button, makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    minWidth: 400,
  },
  title: {
    '& h2': {
      fontSize: '1.25rem',
      letterSpacing: '-0.01em',
    },
  },
  content: {
    paddingTop: '8px !important',
  },
  contentText: {
    color: theme.palette.text.secondary,
    fontSize: '0.95rem',
  },
  actions: {
    padding: theme.spacing(2, 3, 2),
  },
  cancelBtn: {
    color: theme.palette.text.secondary,
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  confirmBtn: {
    background: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
    color: '#fff',
    boxShadow: '0 4px 15px rgba(239,68,68,0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #f87171 0%, #ef4444 100%)',
      boxShadow: '0 6px 20px rgba(239,68,68,0.4)',
    },
  },
}));

export default function ConfirmDialog({ open, title, message, onConfirm, onCancel, confirmText = 'Confirm', confirmColor = 'error' }) {
  const classes = useStyles();

  return (
    <Dialog 
      open={open} 
      onClose={onCancel}
      classes={{ paper: classes.paper }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          backdropFilter: 'blur(4px)',
        }
      }}
    >
      <DialogTitle className={classes.title}>{title || 'Confirm Action'}</DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.contentText}>
          {message || 'Are you sure you want to proceed?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button 
          onClick={onCancel} 
          className={classes.cancelBtn}
          disableElevation
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          className={confirmColor === 'error' ? classes.confirmBtn : ''}
          color={confirmColor === 'error' ? 'default' : confirmColor}
          variant="contained"
          disableElevation
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}